module.exports = __webpack_public_path__ + "img/mtsj-logo.e80afcd0.png";